import DOMPurify from 'isomorphic-dompurify';

const completelyDecodeString = (str: string): string => {
    try {
        const decodedStr = decodeURIComponent(str);

        if (decodedStr === str) {
            return decodedStr;
        }

        return completelyDecodeString(decodedStr);
    } catch {
        return str;
    }
};

export const stripHtml = (str?: string): string =>
    str
        ? DOMPurify.sanitize(completelyDecodeString(str), {
              ALLOWED_TAGS: [],
              KEEP_CONTENT: false,
          })
        : '';
